import React from 'react'
import { Form } from 'react-bootstrap'
import { MessageVariableButtons } from '../MessageVariableButtons'
import { MessageVariableChips } from '../MessageVariableButtons/MessageVariableChips'
//@ts-ignore
import styles from './styles.module.scss'

type MessageVariavelProps = {
  label: string
  value: string
}

type VariableLayout = 'buttons' | 'chips'

type Props = {
  onAddVariable: (variable: string) => void
  value: string
  setValue: (v: string) => void
  title?: string | false
  legend?: boolean
  messagevariables?: MessageVariavelProps[]
  variableLayout?: VariableLayout
  placeholder?: string
  maxLength?: number
  showCharCounter?: boolean
  hideLabel?: boolean
}

export const TextArea = ({
  onAddVariable,
  value,
  setValue,
  title = 'Mensagem',
  legend = true,
  messagevariables = [],
  variableLayout = 'buttons',
  placeholder,
  maxLength,
  showCharCounter = false,
  hideLabel = false
}: Props) => {
  const len = value?.length ?? 0
  const cap = maxLength ?? 4096
  const counterColor =
    len > 4000 ? '#dc3545' : len > 3500 ? '#c9a000' : '#6c757d'

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const next = e.target.value
    if (maxLength != null && next.length > maxLength) {
      setValue(next.slice(0, maxLength))
      return
    }
    setValue(next)
  }

  return (
    <Form.Group className="mb-3">
      {!hideLabel && title !== false && (
        <Form.Label style={{ marginTop: 20 }}>{title || 'Mensagem'}</Form.Label>
      )}
      {variableLayout === 'chips' ? (
        <MessageVariableChips
          onAddVariable={onAddVariable}
          variables={messagevariables}
        />
      ) : (
        <MessageVariableButtons
          onAddVariable={onAddVariable}
          variables={messagevariables}
        />
      )}
      <div className={showCharCounter ? styles.textareaWrap : undefined}>
        <Form.Control
          id="message-text-area"
          as="textarea"
          rows={10}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
        {showCharCounter ? (
          <span
            className={styles.charCounter}
            style={{
              color: counterColor,
              transition: 'color 0.2s ease'
            }}
          >
            {len} / {cap} caracteres
          </span>
        ) : null}
      </div>
      {legend ? (
        <>
          <Form.Text className={styles.formText}>
            {`Você pode usar variáveis para personalizar a mensagem. Exemplo: Olá {nome}, tudo bem?.`}
          </Form.Text>
          <Form.Text className={styles.formText}>
            Para colocar em negrito, coloque o texto entre asteriscos. Exemplo: *
            <b>Olá</b>*, tudo bem?.
          </Form.Text>
          <Form.Text className={styles.formText}>
            Para colocar em itálico, coloque o texto entre underline. Exemplo: _
            <i>Olá</i>_, tudo bem?.
          </Form.Text>
          <Form.Text className={styles.formText}>
            Para colocar em negrito e itálico, coloque o texto entre asteriscos e
            underline. Exemplo: *_
            <b>
              <i>Olá</i>
            </b>
            _*, tudo bem?.
          </Form.Text>
          <Form.Text className={styles.formText}>
            Para deixar riscado, coloque o texto entre til. Exemplo: ~<s>Olá</s>~,
            tudo bem?.
          </Form.Text>
          <Form.Text className={styles.formText}>
            <b style={{ color: '#dc3545' }}>ATENÇÃO:</b> Não utilize *, _ ou ~ após um
            espaço. Por exemplo: "*Olá cliente *"
          </Form.Text>
        </>
      ) : (
        <></>
      )}
    </Form.Group>
  )
}
